<template>
  <div>
    <l-tables
      ref="studentTable"
      :tableConfig="tableConfig"
      :searchParams="searchData"
      :condition="condition"
      :noCreatText="noCreatText"
      :ImgSrc="nullImg"
      :emptyImgSrc="emptyImgSrc"
      @tableChange="handleTableHeaderChange"
      :hasBack="true"
    >
      <template slot="searchConditions">
        <div class="search-conditions">
          <a-input v-model="keyword" @change="search" maxlength="30" :placeholder="$t('student.classStudent.searchPlaceholder')" class="search-item">
            <img slot="prefix" :src="require('@/assets/icons/icon_ss.png')" />
            <img
              class="clear"
              v-if="keyword"
              slot="suffix"
              @click=";(keyword = undefined), search()"
              :src="require('@/assets/icons/icon_gb.png')"
            />
          </a-input>
        </div>
      </template>
      <template slot="searchActions">
        <a-button type="primary" @click="addStudent">{{ $t('student.classStudent.addStudent') }}</a-button>
      </template>
      <template #status="{ record }">
        <a-tag :color="record.status == 1 ? 'green' : 'red'">
          {{ record.status == 1 ? $t('student.classStudent.status.normal') : $t('student.classStudent.status.disabled') }}
        </a-tag>
      </template>
      <template #operateCustom="{ record }">
        <a-button type="link" @click="event => moveStudent(record, event)">{{ $t('student.classStudent.move') }}</a-button>
        <a-button type="link" @click="event => removeStudent(record.id, event)">{{ $t('student.classStudent.remove') }}</a-button>
      </template>
    </l-tables>

    <!-- 添加学生弹窗 -->
    <add-student-modal
      :visible="modalVisible"
      :classId="$route.query.id"
      :classType="$route.query.type"
      @cancel="handleModalCancel"
      @success="handleModalSuccess"
    />

    <!-- 添加移动学生弹窗 -->
    <a-modal
      :title="$t('student.classStudent.moveStudent')"
      :visible="moveModalVisible"
      @ok="handleMoveOk"
      @cancel="handleMoveCancel"
      :confirmLoading="moveConfirmLoading"
    >
      <div class="move-info">
        <div class="info-item">
          <span>{{ $t('student.classStudent.studentName') }}：</span>
          <div>
            <a-input disabled v-model="currentStudent.name"></a-input>
          </div>
        </div>
        <div class="info-item">
          <span>{{ $t('student.classStudent.studentNumber') }}：</span>
          <div>
            <a-input disabled v-model="currentStudent.studentNumber"></a-input>
          </div>
        </div>
      </div>
      <a-form-model ref="moveForm" :model="moveForm" :rules="moveRules">
        <a-form-model-item :label="$t('student.classStudent.moveTo')" prop="majorId" v-if="moveForm.type === '1'">
          <a-cascader
            v-model="moveForm.majorId"
            class="search-item"
            :options="majorOptions"
            :placeholder="$t('student.classStudent.selectMajor')"
            @change="handleMajorChange"
          />
        </a-form-model-item>
        <a-form-model-item :label="$t('class.classNameLabel')" prop="classId">
          <a-select v-model="moveForm.classId" :placeholder="$t('student.classStudent.selectClass')">
            <a-select-option v-for="cls in classOptions" :key="cls.value" :value="cls.value">
              {{ cls.label }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
    
    <!-- 移除学生确认弹窗 -->
    <tip-modal
      @ok="del"
      :visible="delVisible"
      @cancel="delVisible = false"
      :desc="`
        <p>${$t('student.classStudent.removeConfirm')}</p>
        <p class='placeholder'>${$t('student.classStudent.removeConfirmTip')}</p>`"
    />
  </div>
</template>

<script>
import LTables from '@/components/LTables/index.vue'
import AddStudentModal from './components/AddStudentModal.vue'
import { getAdminOrgList } from '@/api/lesson'
import { removeClassStudent, getAllClassList, moveStudent } from '@/api/admin'
import TipModal from '@/components/tipModal/index.vue'

export default {
  components: {
    LTables,
    AddStudentModal,
    TipModal
  },
  data() {
    return {
      keyword: undefined,
      noCreatText: this.$t('student.classStudent.noStudents'),
      nullImg: require('@/assets/img/trainingRoomlistNull.png'),
      emptyImgSrc: require('@/assets/img/bj_zanwu_2.png'),
      searchData: {
        keyword: ''
      },
      delVisible: false,
      delId: undefined,
      tableConfig: {
        tableName: this.$t('student.classStudent.title'),
        tableColumns: [
          {
            title: this.$t('student.classStudent.columns.id'),
            dataIndex: 'index',
            key: 'index',
            align: 'center'
          },
          {
            title: this.$t('student.classStudent.columns.studentName'),
            dataIndex: 'name',
            key: 'name',
            align: 'center'
          },
          {
            title: this.$t('student.classStudent.columns.loginAccount'),
            dataIndex: 'username',
            key: 'username',
            align: 'center'
          },
          {
            title: this.$t('student.classStudent.columns.studentNumber'),
            dataIndex: 'studentNumber',
            key: 'studentNumber',
            align: 'center'
          },
          {
            title: this.$t('student.classStudent.columns.status'),
            dataIndex: 'status',
            key: 'status',
            align: 'center',
            scopedSlots: { customRender: 'status' }
          },
          {
            title: this.$t('student.classStudent.columns.operation'),
            dataIndex: 'operate',
            key: 'operate',
            width: 200,
            align: 'center',
            scopedSlots: { customRender: 'operateCustom' }
          }
        ],
        tablePort: {
          list: '/student/list',
          del: '/class/remove-student'
        }
      },
      condition: {
        classIds: [this.$route.query.id]
      },
      modalVisible: false,
      moveModalVisible: false,
      moveConfirmLoading: false,
      currentStudent: {},
      moveForm: {
        type: this.$route.query.type,
        majorId: [],
        classId: undefined,
        studentId: undefined
      },
      moveRules: {
        type: [{ required: true, message: this.$t('student.classStudent.rules.selectClassType'), trigger: 'change' }],
        classId: [{ required: true, message: this.$t('student.classStudent.rules.selectClass'), trigger: 'change' }]
      },
      majorOptions: [],
      classOptions: []
    }
  },
  created() {
    // this.searchData.classIds = [this.$route.query.id]
    
  },
  mounted() {
    this.tableConfig.tableName = `${this.$route.query.name} - ${this.$t('student.classStudent.management')}`
    this.getClassList()
  },
  methods: {
    search() {
      this.searchData.keyword = this.keyword
    },
    handleTableHeaderChange([filters, getList]) {
      getList()
    },
    goBack() {
      this.$router.push({ name: 'classList' })
    },
    addStudent() {
      this.modalVisible = true
    },
    moveStudent(record, event) {
      event.currentTarget.blur()
      this.currentStudent = record
      this.moveForm.type = this.$route.query.type
      this.moveForm.studentId = record.id
      this.moveModalVisible = true
      this.getMajorList()
    },
    async removeStudent(id, event) {
      event.currentTarget.blur()
      this.delId = id
      this.delVisible = true
    },
    async del() {
      try {
        const res = await removeClassStudent({
          classId: this.$route.query.id,
          studentId: this.delId
        })
        if (res.code === 200) {
          this.$message.success(this.$t('student.classStudent.removeSuccess'))
          this.delVisible = false
          this.$refs.studentTable.getList()
        }
      } catch (error) {
        console.error('移除学生失败:', error)
        this.$message.error(this.$t('student.classStudent.removeFailed'))
      }
    },
    handleModalCancel() {
      this.modalVisible = false
    },
    handleModalSuccess() {
      this.modalVisible = false
      this.$refs.studentTable.getList()
    },
    async getMajorList() {
      try {
        const res = await getAdminOrgList()
        if (res.code === 200) {
          this.majorOptions = []
          for (const item of res.data.list) {
            this.majorOptions.push({
              value: item.id,
              label: item.name,
              children: item.child.map(items => {
                return {
                  value: items.id,
                  label: items.name,
                  children: items.child.map(itemt => {
                    return {
                      value: itemt.id,
                      label: itemt.name
                    }
                  })
                }
              })
            })
          }
        }
      } catch (error) {
        console.error('获取专业列表失败:', error)
        this.$message.error(this.$t('student.classStudent.getMajorListFailed'))
      }
    },
    handleTypeChange(value) {
      this.moveForm.type = value
      this.getClassList()
    },
    async handleMajorChange(value) {
      this.moveForm.majorId = value
      this.moveForm.classId = undefined
      this.getClassList()
    },
    async getClassList() {
      try {
        const res = await getAllClassList({
          professionId: this.moveForm.majorId[this.moveForm.majorId.length - 1],
          type: this.moveForm.type
        })
        if (res.code === 200) {
          this.classOptions = res.data.list.map(cls => ({
            label: cls.name,
            value: cls.id
          }))
        }
      } catch (error) {
        console.error('获取班级列表失败:', error)
        this.$message.error(this.$t('student.classStudent.getClassListFailed'))
      }
    },
    async handleMoveOk() {
      try {
        const valid = await this.$refs.moveForm.validate()
        if (valid) {
          this.moveConfirmLoading = true
          const res = await moveStudent({
            studentId: this.moveForm.studentId,
            classId: this.$route.query.id,
            toClassId: this.moveForm.classId
          })
          if (res.code === 200) {
            this.$message.success(this.$t('student.classStudent.moveSuccess'))
            this.moveModalVisible = false
            this.$refs.moveForm.resetFields()
            this.$refs.studentTable.getList()
          }
        }
      } catch (error) {
        console.error('移动学生失败:', error)
        this.$message.error(this.$t('student.classStudent.moveFailed'))
      } finally {
        this.moveConfirmLoading = false
      }
    },
    handleMoveCancel() {
      this.moveModalVisible = false
      this.$refs.moveForm && this.$refs.moveForm.resetFields()
    }
  }
}
</script>

<style lang="less" scoped>
.search-conditions {
  display: flex;
  align-items: center;
  .search-item {
    margin-right: 16px;
    width: 240px;
  }
}
/deep/ .ant-select {
  width: 100%;
}

.move-info {
  margin-bottom: 12px;
  display: flex;
  justify-content: space-between;
  .info-item {
    margin-bottom: 8px;
    width: 48%;
    &:last-child {
      margin-bottom: 0;
    }
    > span:first-child {
      display: inline-block;
      width: 70px;
      color: rgba(0, 0, 0, 0.85);
      padding-bottom: 6px;
    }
  }
}
/deep/ .ant-form-item {
  margin-bottom: 12px;
}
</style>
